import { render } from "./BaseZincButton.vue?vue&type=template&id=5215d550"
import script from "./BaseZincButton.vue?vue&type=script&lang=js"
export * from "./BaseZincButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__